enum CustomMessagingTypes {
    GET_CUSTOM_MESSAGING_MESSAGES = 'GET_CUSTOM_MESSAGING_MESSAGES',
    EDIT_CUSTOM_MESSAGING_MESSAGE = 'EDIT_CUSTOM_MESSAGING_MESSAGE',
    DELETE_CUSTOM_MESSAGING_MESSAGE = 'DELETE_CUSTOM_MESSAGING_MESSAGE',
    ADD_CUSTOM_MESSAGING_MESSAGE = 'ADD_CUSTOM_MESSAGING_MESSAGE',
    CUSTOM_MESSAGING_MESSAGES_LOADING = 'CUSTOM_MESSAGING_MESSAGES_LOADING',

    GET_CUSTOM_MESSAGING_TAGS = 'GET_CUSTOM_MESSAGING_TAGS',
    CUSTOM_MESSAGING_TAGS_LOADING = 'CUSTOM_MESSAGING_TAGS_LOADING',
    CUSTOM_MESSAGING_SINGLE_MESSAGE_LOADING = 'CUSTOM_MESSAGING_SINGLE_MESSAGE_LOADING',
}

export default CustomMessagingTypes;